<script lang="ts" setup>
const contentCardStore = useContentCardStore()
</script>

<template>
  <span v-if="contentCardStore.showNotification" class="content-card-notification" />
</template>

<style lang="postcss">
.content-card-notification {
  display: block;
  width: 0.55rem;
  height: 0.55rem;
  border-radius: 100%;
  border: 1px solid var(--ui-neutral-00);
  background: var(--status-error);
}
</style>
